import styled from "styled-components";

export const Container = styled.div`
  max-width: 1024px;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: auto;
  margin-right: auto;
`;
